import {useQuery} from "@tanstack/react-query";
import {
    readDashboardSetting, readRevenueByHandlerByMonth, readRevenueByHandlerByYear,
    readRevenueByItem, readRevenueByTeamByMonth,
    readRevenueByTeamByQuarter, readRevenueByTeamByYear, readRevenueByUserByMonth
} from "../../../../../api/main/DashboardApi";
import {DashboardSettingSearchParamType} from "../interface";

export const useReadRevenueByUserByMonth = () => {
    const {data} = useQuery({
        queryKey: ["readRevenueByUserByMonth"],
        queryFn: async () => await readRevenueByUserByMonth(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
